import { UtilService } from '$src/js/base/services/UtilService';
import { TranslationService } from '$src/js/base/services/TranslationService';
import { FocusTrapService } from '$js/base/services/FocusTrapService';
import { KeyPressService } from '$js/base/services/KeyPressService';
import { WindowResizeService } from '$js/base/services/WindowResizeService';

export default class BaseModule {
  private static instance: BaseModule | null = null;
  private _utils: UtilService | null = null;
  private _i18n: TranslationService | null = null;
  private _focusTrap: FocusTrapService | null = null;
  private _keypress: KeyPressService | null = null;
  private _windowResize: WindowResizeService | null = null;

  private bootModules = ['utils', 'i18n', 'focusTrap', 'windowResize', 'keypress'] as const;

  static getInstance(): BaseModule {
    BaseModule.instance ??= new BaseModule();
    return BaseModule.instance;
  }

  get utils(): UtilService {
    this._utils ??= new UtilService();
    return this._utils;
  }

  get i18n(): TranslationService {
    this._i18n ??= new TranslationService();
    return this._i18n;
  }

  get focusTrap(): FocusTrapService {
    this._focusTrap ??= new FocusTrapService();
    return this._focusTrap;
  }

  get windowResize(): WindowResizeService {
    this._windowResize ??= new WindowResizeService();
    return this._windowResize;
  }

  get keypress(): KeyPressService {
    this._keypress ??= new KeyPressService();
    return this._keypress;
  }

  /**
   * Boot all modules
   */
  boot(): void {
    type ModuleKey = (typeof this.bootModules)[number];

    this.bootModules.forEach((module: ModuleKey) => {
      return this[module];
    });
  }
}
